import {charcoal} from '../../sass/v2/_exports.sass';

export const CardDesignIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      className={className}
      style={style}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.7,29.3H5.3c-.4,0-.7-.1-.9-.4-.3-.3-.4-.5-.4-.9V4c0-.4,0-.7.4-.9s.5-.4.9-.4h21.3c.4,0,.7,0,.9.4s.4.5.4.9v24c0,.4-.1.7-.4.9s-.5.4-.9.4ZM25.3,26.7V5.3H6.7v21.3h18.7ZM10.7,9.3h10.7v2.7h-10.7v-2.7ZM10.7,14.7h10.7v2.7h-10.7v-2.7ZM10.7,20h6.7v2.7h-6.7v-2.7Z"
        fill={color}
      />
    </svg>
  );
};
